import { Pipe, PipeTransform } from '@angular/core';

/**
 * Currency formatting pipe
 * Usage: {{ amount | appCurrency:'USD' }}
 */
@Pipe({
  name: 'appCurrency',
  standalone: true
})
export class CurrencyPipe implements PipeTransform {
  transform(value: number, currency = 'USD'): string {
    if (value === null || value === undefined) {
      return '';
    }

    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency
    });

    return formatter.format(value);
  }
}
